import React, { useCallback, useEffect, useState } from "react";
import { cdnImg } from "../Utils/cdnImage";
import AuthContext from "../context/AuthContext";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import BetSlipContext from "../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import StackSetting from "./StackSetting";
import { usePolling } from "./usePolling";
import { isEmpty } from "lodash";
import ParlayDial from "./ParlayDial";

const BetSlipParly = () => {
  let betCheckObj = {
    4: "Cricket",
    2: "Tennis",
    1: "Soccer",
    3: "Casino",
  };

  const setShowParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setShowParlyBet;
  });
  const showParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.showParlyBet;
  });
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });
  const amounutRefresh = useContextSelector(AuthContext, (ctx) => {
    return ctx.amounutRefresh;
  });
  const setBetLoader = useContextSelector(AuthContext, (ctx) => {
    return ctx.setBetLoader;
  });

  const [stake, setStake] = useState("");
  const [showDial, setShowDial] = useState(true);
  const [totalOdds, setTotalOdds] = useState("");
  const [setting, setSetting] = useState(false);
  const [loader, setLoader] = useState(false);

  const removeSlip = (id) => {
    setParlyBet((current) => {
      if (current?.length == 1) {
        secureLocalStorage.setItem("parlyBet", []);
      } else {
        secureLocalStorage.setItem(
          "parlyBet",
          current?.filter((res) => {
            return res?.newEventId !== id;
          }),
        );
      }
      return current?.filter((res) => {
        return res?.newEventId !== id;
      });
    });
    if (parlyBet?.length == 1) {
      setShowParlyBet(false);
    }
  };

  const handelDialPad = (item) => {
    let str = stake?.toString() + item?.toString();
    if (str?.length > 6) {
    } else {
      setStake(Number(str));
    }
  };

  useEffect(() => {
    if (parlyBet?.length > 0 && showParlyBet) {
      setTotalOdds(
        parlyBet
          ?.filter((res) => !res?.closed)
          ?.reduce(
            (accumulator, currentValue) =>
              accumulator * currentValue?.sportsBookSelectionObject?.odds,
            1,
          )
          ?.toFixed(2),
      );
    }
  }, [parlyBet, showParlyBet]);

  const getOdds = async () => {
    const eventIds =
      parlyBet?.map((res) => res?.betfairEventId).join(",") || "";
    if (!eventIds) return;

    const { status, data } = await apiGet(
      `${apiPath.getPremiumFancy}?events=${eventIds}&multi=true`,
    );

    if (status !== 200 || !data?.success) return;

    setParlyBet((current) => {
      const results = data?.results || [];
      const updatedBets = current.map((item) => {
        // Find matching result object for the current item
        const obj = results.find(
          (res) => res?.eventId === item?.eventId && res?.id === item?.id,
        );
        if (isEmpty(obj) || obj?.sportsBookSelection?.length == 0) {
          return { ...item, closed: true }; // No data → close this bet
        }

        // Find the selected inner object
        const innerObj = obj.sportsBookSelection.find(
          (pop) => pop?.id === item?.sportsBookSelectionObject?.id,
        );
        const isClosed =
          obj?.apiSiteStatus === "SUSPENDED" ||
          Number(obj?.marketStatus) !== 1 ||
          Number(innerObj?.isActive) !== 1;
        // Merge necessary fields dynamically instead of manually rewriting all keys

        return {
          ...obj,
          sportsBookSelectionObject: innerObj,
          selectObj: obj?.selectObj,
          spark: getSparkColor(
            innerObj?.odds,
            item?.sportsBookSelectionObject?.odds,
            item?.spark,
          ),
          newEventId: item?.newEventId,
          eventName: item?.eventName,
          marketId: item?.marketId,
          closed: isClosed,
        };
      });

      secureLocalStorage.setItem("parlyBet", updatedBets);
      return updatedBets;
    });
  };
  const getSparkColor = (newOdds, oldOdds, prevSpark) => {
    if (newOdds > oldOdds) return "green";
    if (newOdds < oldOdds) return "red";
    if (newOdds === oldOdds) return prevSpark;
    return "";
  };
  const fetchPremium = useCallback(async () => {
    if (showParlyBet) {
      await getOdds();
    }
  }, [showParlyBet]);

  usePolling(fetchPremium, 4000, showParlyBet);

  const clear = () => {
    let str = stake?.toString();
    if (str?.length == 1) {
      setStake("");
    } else {
      setStake(str.substring(0, str.length - 1));
    }
  };

  const placeBet = async () => {
    if (!parlyBet || parlyBet.length < 2) {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: "Please select at least 2 parlay bets",
        status: true,
      });
      return;
    }

    // Find bets that are closed
    const closedBets = parlyBet.filter((res) => res?.closed);

    // If any bets are closed, show error and stop execution
    if (closedBets.length > 0) {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: `Market are closed ${closedBets
          .map((res) => res?.eventId)
          .join(", ")}`,
        status: true,
      });
      return;
    }
    setLoader(true);
    setBetLoader(true);
    // Prepare date & payload data
    const betPlaceTime = moment().format("YYYY-MM-DD, h:mm:ss");
    const resultArray = parlyBet.map((res) => ({
      eventId: res?.newEventId,
      marketId: res?.marketId,
      fancySelectionId: res?.sportsBookSelectionObject?.id,
      selectionId: res?.id,
      betPlaceTime,
      fancyName: res?.marketName,
      bhav: res?.sportsBookSelectionObject?.odds,
      betType: "back",
      runnerName: res?.sportsBookSelectionObject?.selectionName,
      apiSiteSelectionId: res?.sportsBookSelectionObject?.apiSiteSelectionId,
      betPlaceType: "premiumFancy",
    }));

    const payload = {
      betPlaceTime,
      overallOdds: totalOdds,
      totalAmount: stake,
      bets: resultArray,
    };

    // Send API request
    const { status, data } = await apiPost(apiPath.multiEventPlaceBet, payload);

    if (status === 200 && data?.success) {
      setToastObject({
        type: "success",
        title: "Bet Placed",
        message: `Total Stake USD ${stake} | Max Profit ${
          totalOdds > 0 && stake > 0 ? ((totalOdds - 1) * stake)?.toFixed(2) : 0
        }`,
        status: true,
      });
      amounutRefresh();
      setParlyBet([]);
      secureLocalStorage.removeItem("parlyBet");
      setShowParlyBet(false);
    } else {
      setToastObject({
        type: "error",
        title: "Bet Error",
        message: data?.message,
        status: true,
      });
    }
    setLoader(false);
    setBetLoader(false);
  };
  return (
    <div
      style={{ display: showParlyBet ? "block" : "none" }}
      data-v-ae096703
      className="s-z-70 s-bottom-0 s-rounded-t-5px s-fixed s-w-full"
    >
      <div
        data-v-ae096703
        className="s-relative s-bg-betSlip-light dark:s-bg-betSlip-dark s-text-global-font-default-light dark:s-text-global-font-default-dark s-pt-2 s-rounded-t-12px s-z-10"
      >
        <div data-v-ae096703 className="s-relative s-font-bold s-mb-2">
          <p
            data-v-ae096703
            className="s-global-font-on-light s-text-18px s-text-center s-p-2"
          >
            Bet Slip
          </p>
          <div
            onClick={() => setShowParlyBet(false)}
            data-v-ae096703
            className="s-icon-close s-absolute s-right-5 s-top-2 s-text-base s-cursor-pointer"
          />
        </div>
        <div
          data-v-ae096703
          className="s-divide-y s-divide-black-300 dark:s-divide-black-900"
        >
          <div data-v-ae096703 className="s-max-h-72 s-overflow-y-scroll">
            {parlyBet?.length > 0
              ? parlyBet?.map((res) => {
                  return (
                    <div data-v-ae096703 className="s-w-full s-mb-2 s-px-2">
                      <div
                        data-v-ae096703
                        className="s-p-2 s-w-full s-flex s-items-center s-bg-black-300 dark:s-bg-black-700 s-rounded-t-5px"
                      >
                        {res?.closed && (
                          <span
                            data-v-ae096703
                            className="s-my-4px s-bg-black-600 s-leading-120 s-py-1 s-mr-2 s-text-black-300 dark:s-text-black-400 s-px-2 s-rounded s-font-bold s-text-17px"
                          >
                            Closed
                          </span>
                        )}
                        {res?.closed ? (
                          <div
                            data-v-ae096703
                            className="s-text-black-400 dark:s-text-black-500 s-py-4px s-pr-2 s-w-full s-text-17px"
                          >
                            <span
                              data-v-ae096703
                              className="s-leading-120 s-inline-flex"
                            >
                              {betCheckObj[res?.markets?.eventType]}
                            </span>
                            <span data-v-ae096703>
                              <i
                                data-v-ae096703
                                className="s-icon-triangle-black-400 dark:s-icon-triangle-black-600 s-text-10px s-inline-block s-align-middle dark:s-border-l-black-600"
                              />
                            </span>
                            <span
                              data-v-ae096703
                              className="s-break-words s-leading-120"
                            >
                              <span
                                data-v-ae096703
                                className="s-font-bold s-inline-flex"
                              >
                                {res?.eventName}
                              </span>
                            </span>
                          </div>
                        ) : (
                          <div
                            data-v-ae096703
                            className="s-pr-2 s-w-full s-text-17px"
                          >
                            <span
                              data-v-ae096703
                              className="s-leading-120 s-inline-flex"
                            >
                              {betCheckObj[res?.markets?.eventType]}
                            </span>
                            <span data-v-ae096703>
                              <i
                                data-v-ae096703
                                className="s-icon-triangle-black-700 s-text-10px s-inline-block s-align-middle dark:s-border-l-black-600"
                              />
                            </span>
                            <span
                              data-v-ae096703
                              className="s-break-words s-leading-120"
                            >
                              <span
                                data-v-ae096703
                                className="s-font-bold s-inline-flex"
                              >
                                {res?.eventName}
                              </span>
                            </span>
                          </div>
                        )}
                        <span
                          onClick={() => removeSlip(res?.newEventId)}
                          data-v-ae096703
                          className="s-icon-del s-self-center s-inline-block s-text-18px s-text-black-600"
                        />
                      </div>
                      {!res?.closed && (
                        <div
                          data-v-ae096703
                          className="s-p-2 s-w-full s-bg-black-100 dark:s-bg-betSlip-info-dark s-rounded-b-lg"
                        >
                          <div className="s-relative s-mb-2 s-flex s-justify-between s-items-center s-overflow-hidden s-rounded-3px">
                            <p className="s-w-10/12 s-text-17px s-font-bold s-break-all s-leading-120">
                              {res?.sportsBookSelectionObject?.selectionName}
                            </p>
                            <div
                              className={`${
                                res?.spark == "green"
                                  ? "s-text-forecast-up-text"
                                  : ""
                              } s-relative s-w-48px s-h-27px s-flex s-justify-center s-items-center s-text-17px s-font-bold s-text-center s-bg-parlay-betInfo-light dark:s-bg-parlay-betInfo-dark s-rounded-3px dark:s-text-global-font-default-dark`}
                            >
                              {res?.sportsBookSelectionObject?.odds}
                            </div>
                            {res?.spark == "green" && (
                              <span class="s-icon-parlay-up s-absolute s-text-12px -s-top-2px -s-right-2px s-text-forecast-up-text s-scale-75"></span>
                            )}
                          </div>
                          <p className="s-text-14px">{res?.marketName}</p>
                        </div>
                      )}
                    </div>
                  );
                })
              : []}
          </div>
          <div data-v-ae096703 className="s-px-2">
            <div data-v-ae096703 className="s-py-2 s-flex s-justify-between">
              <div
                data-v-ae096703
                className="s-flex s-justify-center s-items-center s-text-14px"
              >
                <span
                  data-v-ae096703
                  className="s-mr-2 first-letter: s-font-bold"
                >
                  Avg Odds
                </span>
                <span data-v-ae096703 className="s-text-warning s-font-bold">
                  @{" "}
                  {parlyBet?.length > 0 ? (totalOdds == 1 ? 0 : totalOdds) : 0}
                </span>
                <span
                  data-v-ae096703
                  className="s-icon-arrow-left s-rotate-180 s-ml-7px s-text-6px s-text-forecast-up-text"
                />
                <span
                  data-v-ae096703
                  className="s-text-forecast-up-text s-font-bold"
                >
                  {totalOdds > 0 && stake > 0
                    ? ((totalOdds - 1) * stake)?.toFixed(2)
                    : 0}
                </span>
              </div>
              <div
                data-v-ae096703
                className="s-flex s-justify-center s-items-center"
              >
                <span
                  data-v-ae096703
                  className="s-mr-2 s-text-14px s-font-bold"
                >
                  Stake
                </span>
                <div
                  onClick={() => setShowDial(true)}
                  data-v-ae096703
                  className="s-flex s-w-90px s-h-27px s-text-center s-leading-normal s-rounded"
                >
                  <span
                    data-v-ae096703
                    name="stake"
                    className={`s-input-field s-h-27px ${
                      showDial ? "is-focus" : "is-default"
                    } `}
                  >
                    {stake}
                  </span>
                </div>
              </div>
            </div>
            {showDial && (
              <ParlayDial
                clear={clear}
                setShowDial={setShowDial}
                handelDialPad={handelDialPad}
                setSetting={setSetting}
              />
            )}
          </div>
          <div
            data-v-ae096703
            className="s-px-2 s-py-3 s-flex s-justify-between s-items-center"
          >
            <div data-v-ae096703 className="s-py-1">
              <div data-v-ae096703 className="s-mb-0.5">
                <span
                  data-v-ae096703
                  className="s-mr-2 s-text-18px fs-ont-normal"
                >
                  Total Stakes
                </span>
                <span data-v-ae096703 className="s-text-18px s-font-bold" />
              </div>
              <div data-v-ae096703 className="s-text-base">
                <span data-v-ae096703 className="s-mr-2 s-font-normal">
                  Max Profit
                </span>
                <span data-v-ae096703 className="s-font-bold">
                  {totalOdds > 0 && stake > 0
                    ? ((totalOdds - 1) * stake)?.toFixed(2)
                    : 0}
                </span>
              </div>
            </div>
            <button
              onClick={() => placeBet()}
              data-v-bf7df09e
              data-v-ae096703
              className="btn s-btn-normal s-relative s-text-14px s-p-3 s-font-bold s-rounded s-flex s-justify-center s-items-center disabled:s-bg-black-300 dark:disabled:s-bg-black-700 disabled:s-text-black-600 dark:disabled:s-text-black-600 disabled:s-cursor-not-allowed s-overflow-hidden a active:s-bg-opacity-10 s-w-181px s-h-50px s-flex s-justify-center s-items-center s-rounded-md s-bg-button-normal s-text-17px"
              disabled={stake > 0 && parlyBet?.length > 0 ? false : true}
              type="submit"
            >
              <div
                data-v-2f9c23fd
                data-v-bf7df09e
                className="wrapper s-w-full s-h-full s-absolute s-overflow-hidden s-top-0 s-left-0 s-z-10"
                style={{ "--0b879273": "0" }}
              >
                <span
                  data-v-2f9c23fd
                  className="mask s-w-full s-h-full s-opacity-10 s-bg-black-900 s-absolute s-left-0 s-top-0"
                  style={{ display: "none" }}
                />
                <span
                  data-v-2f9c23fd
                  className="feedback s-block s-bg-white s-bg-opacity-25 s-rounded-full s-mix-blend-overlay s-absolute"
                  style={{ display: "none" }}
                />
              </div>
              {/**/} Place Bet{" "}
            </button>
          </div>
          <div
            data-v-ae096703
            className="s-p-2 s-flex s-justify-between s-items-center"
          >
            <div
              data-v-ae096703
              className="s-checkbox s-text-14px s-text-black-900 dark:s-text-black-400"
            >
              <input
                id="accept-any-odds"
                name="accept-any-odds"
                type="checkbox"
                className="s-hidden"
              />
              <label
                htmlFor="accept-any-odds"
                className="s-flex s-justify-start s-items-center s-select-none s-text-checkbox-icon"
              >
                <span className="s-flex s-justify-center s-items-center s-border s-border-solid s-border-checkbox-boder s-mr-1.5 s-w-4 s-h-4 s-rounded s-bg-checkbox-checked">
                  <span className="s-icon-check s-text-checkbox-icon s-text-8px s-font-bold" />
                </span>{" "}
                Accept any odds
              </label>
            </div>
            <div data-v-ae096703 className="s-flex s-items-center s-space-x-1">
              <mark
                data-v-ae096703
                className="s-text-11px s-bg-black-300 s-text-black s-leading-normal s-px-2 s-rounded"
              >
                Max
              </mark>
              <span
                data-v-ae096703
                className="s-text-12px s-text-black-600 s-font-bold"
              />
            </div>
          </div>
        </div>
        <div data-v-ae096703 style={loader ? {} : { display: "none" }}>
          <div
            data-v-ae096703
            className="s-absolute s-z-10 s-top-0 s-left-0 s-w-full s-h-full s-bg-black-800 s-opacity-80 s-rounded-t-5px"
          />
          <div
            data-v-ae096703
            className="s-absolute s-z-10 s-top-0 s-left-0 s-w-full s-h-full s-flex s-items-center s-justify-center"
          >
            <img
              data-v-ae096703
              width={147}
              height={124}
              src={cdnImg("/assets/IconBetting/loading-bet.webp")}
              alt
            />
          </div>
        </div>
      </div>
      <div
        data-v-ae096703
        className="s-bet-slip-gradient s-absolute s-w-full s-h-120px dark:s-h-64px s-top-13px dark:-s-top-17px -s-translate-y-1/2"
      />
      {setting && <StackSetting handleStackSetting={setSetting} />}
    </div>
  );
};

export default BetSlipParly;
